import { WarningOutlined } from "@ant-design/icons"
import { Tag, Tooltip } from "antd"

interface ContractFigureWarningProps {
  alert?: { severity: "warning" | "critical"; message: string }
}

/**
 * Marks a contract figure the milestone plan no longer adds up to.
 *
 * It sits beside the figure it is about rather than on the row it is computed
 * from, because the contract value is the number the user has to reconcile
 * the plan against.
 */
export function ContractFigureWarning({ alert }: ContractFigureWarningProps) {
  if (!alert) return null

  return (
    <Tooltip title={alert.message}>
      <Tag
        color={alert.severity === "critical" ? "error" : "warning"}
        className="m-0 px-1 leading-none"
        data-testid="contract-figure-warning"
      >
        <WarningOutlined />
      </Tag>
    </Tooltip>
  )
}
